import { useState } from 'react';
import { allAuth } from '@round/api';

type State = 'idle' | 'pending' | 'success' | 'error';

export default function useResendCode() {
    const [resendState, setResendState] = useState<State>('idle');
    const [resendCodeError, setResendCodeError] = useState<string | null>(null);

    const resendCode = async (sessionToken: string): Promise<boolean> => {
        try {
            setResendState('pending');
            const response = await allAuth.resendCode(sessionToken);

            if (response.status === 429) {
                setResendState('error');
                setResendCodeError('Too many requests');
                return false;
            }

            if (response.status === 409) {
                setResendState('error');
                setResendCodeError('Could not resend code');
                return false;
            }

            setResendState('success');
            return true;
        } catch {
            setResendState('error');
            setResendCodeError('Could not resend code');
            return false;
        }
    };

    return {
        isLoading: resendState === 'pending',
        isSuccess: resendState === 'success',
        isError: resendState === 'error',
        errorMessage: resendCodeError,
        resendCode,
    };
}
